import { FORMS_ID } from "application/constants/app-constants";

export default function getFormId() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return FORMS_ID[urlParams?.get("country") ?? "gb"] ?? FORMS_ID["gb"];
}
